import type { AuthSession } from '@jira/shared';

import { api } from './api';

export async function postLogin(email: string, password: string): Promise<AuthSession> {
  const { data } = await api.post<AuthSession>('/auth/login', { email, password });
  return data;
}

export async function postLogout(refreshToken: string): Promise<void> {
  await api.post('/auth/logout', { refreshToken });
}

export async function postForgotPassword(email: string): Promise<void> {
  await api.post('/auth/forgot-password', { email });
}

export async function postResetPassword(token: string, password: string): Promise<void> {
  await api.post('/auth/reset-password', { token, password });
}

export async function getInvitation(token: string) {
  const { data } = await api.get<{
    organizationName: string;
    roleName: string;
    inviteeEmail: string;
    expiresAt: string;
  }>(`/invitations/${encodeURIComponent(token)}`);
  return data;
}

export async function postAcceptInvitation(
  token: string,
  name: string,
  password: string,
): Promise<AuthSession> {
  const { data } = await api.post<AuthSession>(
    `/auth/accept-invitation?token=${encodeURIComponent(token)}`,
    { name, password },
  );
  return data;
}

export async function refreshMe() {
  const { data } = await api.get<{ user: AuthSession['user'] }>('/auth/me');
  return data.user;
}
